// Every book's cover photo(s) happen to sit at the *end* of its post body
// as-migrated (after the Editeur/Nb pages/ISBN/Description text) - matching
// champis.net's own /books/:category, which puts them at the top instead,
// means pulling them out of the body's HTML and rendering them in their own
// strip above it, rather than changing anything about how the content
// itself is authored or migrated.
//
// Each one is an attached image as fof/upload renders it, inside the
// <figure> (and optional <figcaption>) ImageCaptionFix (migration/) wraps it
// in. Found through the DOM rather than matched as text: the server sends
// `<p><figure ...>...</figure></p>`, but a <figure> can't live inside a <p>,
// so the HTML the browser hands back (Post#contentHtml) is already split
// into `<p></p><figure ...>...</figure><p></p>` - a regex written against
// either form silently stops matching the other (the covers fell back into
// the text, full size, once captions added the <figure>). Parsed into an
// inert <template>, so nothing loads before the page actually renders it.
export default function splitCoverImages(html) {
  const template = document.createElement('template');
  template.innerHTML = html;
  const images = Array.from(template.content.querySelectorAll('figure.FoFUpload--Upl-Image-Preview-Figure'), figure => {
    // The empty <p> pair each figure's own paragraph was split into.
    for (const sibling of [figure.previousElementSibling, figure.nextElementSibling]) {
      if (sibling?.tagName === 'P' && sibling.innerHTML.trim() === '') {
        sibling.remove();
      }
    }
    figure.remove();
    return figure.outerHTML;
  });
  return {
    images,
    text: template.innerHTML
  };
}
flarum.reg.add('champis-others', 'forum/utils/splitCoverImages', splitCoverImages);